<template>
	<div class="row">
		<div class="col-xs-12">
			<ux-text-field
				label="Name"
				:rules="rules.name"
				:value="method.name"
				@input="updateMethod('name', $event)"
			/>
		</div>

		<template v-if="method.id == 0">
			<div class="col-xs-12">
				<ux-text-field
					label="Street Address"
					class="mb-1"
					:rules="rules.street1"
					v-model="address.street1"
				/>

				<ux-text-field
					hide-label
					v-model="address.street2"
				/>
			</div>

			<div class="col-md-4">
				<ux-text-field
					label="City"
					:rules="rules.city"
					v-model="address.city"
				/>
			</div>

			<div class="col-md-4">
				<ux-select-field
					show-empty
					label="Country"
					empty-text="(select country)"
					empty-value=""
					:items="$options.countries"
					item-text="name"
					item-value="code"
					:rules="rules.country"
					v-model="address.country"
				/>
			</div>

			<div class="col-md-4">
				<ux-select-field
					show-empty
					v-if="regions.list.length > 0"
					:label="regions.label"
					empty-text="(select region)"
					empty-value=""
					:items="regions.list"
					item-text="name"
					item-value="code"
					:rules="rules.region"
					v-model="address.region"
				/>

				<ux-text-field
					v-else
					:label="regions.label"
					:rules="rules.region"
					v-model="address.region"
				/>
			</div>

			<div class="col-xs-12">
				<credit-card-entry ref="creditCard" />
			</div>
		</template>

		<div class="col-xs-12">
			<div class="ux-checkbox-list is-vert">
				<ux-checkbox label="Is primary method" v-model="isPrimary" />
			</div>
		</div>
	</div>
</template>

<script>
import regions from 'common/regions';

import CreditCardEntry from './CreditCardEntry.vue';

export default {
	components: { CreditCardEntry },
	countries: regions.countries,

	props: {
		method: { required: true },
	},

	data() 
	{
		return {
			address: {
				street1: '',
				street2: '',
				city: '',
				postal_code: '',
				country: '',
				region: '',
			},

			rules: {
				name: [ v => !!v || 'Please enter a name for this payment method '],
				street1: [ v => !!v || 'Please enter the street address' ],
				city: [ v => !!v || 'Please enter a city' ],
				//postal_code: [ v => !!v || 'Please enter a postal code' ],
				country: [ v => !!v || 'Please select a country' ],
				region: [ v => !!v || 'Please select a province/state' ],
			}
		}
	},

	computed: {
		regions()
		{
			var titles = { CA: 'Province', US: 'State' };
			return {
				label: titles[this.address.country] || 'Region',
				list: regions.countryRegions[this.address.country] || [],
			};
		},

		isPrimary: {
			get() { return this.method.is_primary || false; },
			set(flag) { this.updateMethod('is_primary', flag); },
		},
	},

	watch: {
		address: {
			deep: true,
			handler() {
				this.updateMethod('billing_addr', { ...this.address });
			}
		}
	},

	methods: {
		updateMethod(field, value)
		{
			var payload = { ...this.method, [field]: value };
			this.$emit('update:method', payload);
		},

		getNonce()
		{
			return this.$refs.creditCard.getNonce();
		}
	}
}
</script>